import { INavData } from '@coreui/angular';

export const navItems: INavData[] = [
  {
    name: 'Dashboard',
    url: '/dashboard',
    icon: 'fas fa-chart-line',
  },
  {
    name: 'User Management',
    url: '/retailer',
    icon: 'fas fa-user-friends',
  },
  {
    name: 'Product Management',
    url: '/product',
    icon: 'fas fa-truck',
  },
  {
    name: 'Category Management',
    url: '/category',
    icon: 'fas fa-list',
    children: [
      {
        name: 'Main Category Management',
        url: '/category/list',
        icon: 'fas fa-cube'
      },
      {
        name: 'Sub category Management',
        url: '/sub-category',
        icon: 'fas fa-box-open'
      },
    ]
  },
  {
    name: 'Time Slot',
    url: '/timeslot',
    icon: 'fas fa-clock',
  },
  {
    name: 'Order Management',
    url: '/order',
    icon: 'fas fa-shopping-cart',
    children: [
      {
        name: 'New Order',
        url: '/order/neworder',
      },
      {
        name: 'In Progress',
        url: '/order/inprogress',
      },
      {
        name: 'Completed',
        url: '/order/complete',
      },
      {
        name: 'Cancelled',
        url: '/order/cancell',
      }
    ]
  },
  {
    name: 'Payment Management',
    url: '/payment',
    icon: 'fas fa-rupee-sign'
  },
  {
    name: 'Unit Management',
    url: '/unit',
    icon: 'fas fa-balance-scale-right',
  },
  {
    name: 'Email Template',
    url: '/template',
    icon: 'fas fa-envelope'
  },
  {
    name: 'Settings',
    url: '/settings',
    icon: 'fas fa-cog',
    children: [
      {
        name: 'General',
        url: '/settings/general',
        icon: 'fas fa-user-cog',
      },
      {
        name: 'SMTP',
        url: '/settings/smtp',
        icon: 'fas fa-mail-bulk',
      },
      {
        name: 'SMS',
        url: '/settings/sms',
        icon: 'fas fa-sms'
      },
      {
        name: 'Push Notification',
        url: '/settings/push-notification',
        icon: 'fas fa-bell'
      },
      {
        name: 'Change Password',
        url: '/settings/change-password',
        icon: 'fas fa-key'
      }
    ]
  }
];
